import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({
      eventCoalescing: true
    }),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideFirebaseApp(() => initializeApp({
      projectId: "voyagex-ai",
      appId: "1:395253125688:web:ef973c7e70160c330bcccd",
      storageBucket: "voyagex-ai.firebasestorage.app",
      apiKey: "AIzaSyATE_JLmmnl6dLmZ7YJ1CEuwJWfIaSgQj0",
      authDomain: "voyagex-ai.firebaseapp.com",
      messagingSenderId: "395253125688"
    })),
    provideFirestore(() => getFirestore()),
  ]
};
